import { z } from "zod";

// Note: Due to module resolution issues between packages during Vite build,
// we're duplicating the schemas here.
// These MUST match the values in packages/shared/src/schemas/cashOutV2.ts

// Currency validation - allows 0 and positive numbers with up to 2 decimal places
const currencySchema = z
  .number()
  .min(0, "Amount cannot be negative")
  .transform((val) => Math.round(val * 100) / 100);

// Optional currency that defaults to 0
const optionalCurrencySchema = currencySchema.optional().default(0);

// Venue schema - must match shared/src/constants/venues.ts
const venueSchema = z.enum(["THE_BULLWHEEL", "FOURTH_ACE"] as const);

/**
 * Form input schema - what users enter in the form
 */
export const cashOutV2FormInputSchema = z.object({
  // Header
  entryDate: z.coerce.date(),
  venue: venueSchema,

  // Section 1: Toast Sales Data
  netSalesTotal: optionalCurrencySchema,
  totalGratuityAndFees: optionalCurrencySchema,
  taxes: optionalCurrencySchema,
  giftCardSales: optionalCurrencySchema,
  discounts: optionalCurrencySchema,
  totalNonCashTips: optionalCurrencySchema,

  // Section 3: Account Info - Staff Account
  staffAccountAmount: optionalCurrencySchema,
  staffAccountTip: optionalCurrencySchema,
  staffAccountGratuity: optionalCurrencySchema,

  // Section 3: Account Info - House Account
  houseAccountAmount: optionalCurrencySchema,
  houseAccountTip: optionalCurrencySchema,
  houseAccountGratuity: optionalCurrencySchema,

  // Section 4: Payment Centres - Cash
  cashAmount: optionalCurrencySchema,
  cashTip: optionalCurrencySchema,
  cashGratuity: optionalCurrencySchema,

  // Section 4: Payment Centres - Credit
  creditAmount: optionalCurrencySchema,
  creditTip: optionalCurrencySchema,
  creditGratuity: optionalCurrencySchema,

  // Section 4: Payment Centres - Gift Card
  giftCardAmount: optionalCurrencySchema,
  giftCardTip: optionalCurrencySchema,
  giftCardGratuity: optionalCurrencySchema,

  // Notes
  notes: z.string().optional(),
});

export type CashOutV2FormInputSchema = z.infer<typeof cashOutV2FormInputSchema>;
